import { useProductCatalog } from '@hooks/useProductCatalog'
import styles from '@styles/ProductCatalog.module.css'
import ProductCard from '@components/ProductCard'
import SearchBar from '@components/SearchBar'
import { useState, useMemo } from 'react'
import Loading from '@components/Loading'
import { Link } from 'react-router-dom'

const ProductCatalog = () => {
  const { products, loading } = useProductCatalog()
  const [searchTerm, setSearchTerm] = useState('')
  const [searchFilter, setSearchFilter] = useState('brand')

  
  const groupedProducts = useMemo(() => {
    const filtered = products.filter(product => {
      const searchValue = product[searchFilter].toString().toLowerCase()
      return searchValue.includes(searchTerm.toLowerCase())
    })
    
    return filtered.reduce((acc, product) => {
      if (!acc[product.category]) acc[product.category] = []
      acc[product.category].push(product)
      return acc
    }, {})
  }, [products, searchTerm, searchFilter])
  
  if (loading) return <Loading />
  
  return (
    <div className={styles.container}>
      <section className={styles.catalog}>
        <div className={styles.information}>
          <h1 className={styles.title}>Optica Natalu</h1>
          <p className={styles.subcontent}>&apos;Ver con elegancia, vivir con estilo&apos;</p>
          <p className={styles.subcontent}>En Óptica Natalú, la visión y el estilo van de la mano.</p>
          <p className={styles.subcontent}>Nuestra selección de gafas de moda y lentes de contacto te 
            permitirán expresar tu personalidad con elegancia y comodidad.</p>
        </div>
        <h2 className={styles.subtitle}>Nuestro Catálogo</h2>

        <SearchBar
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          searchFilter={searchFilter}
          setSearchFilter={setSearchFilter}
        />

        {Object.entries(groupedProducts).map(([category, categoryProducts]) => (
          <div 
            key={category}
            className={`${category === 'Lentes' ? styles.lentesCategory : styles.categorySection}`}
          >
            <h3 className={styles.categoryTitle}>{category}</h3>
            <div className={`${category === 'Lentes' ? styles.lentesGrid : styles.grid}`}>
              {categoryProducts.slice(0, 5).map((product, index) => {
                const imageUrl = typeof product.image === 'object' ? product.image.url : product.image
                return (
                <ProductCard
                  key={product.id}
                  id={product.id}
                  image={imageUrl}
                  brand={product.brand}
                  reference={product.reference}
                  price={product.price}
                  active={product.active}
                  isFirstImage={index === 0}
                  isLens={category === 'Lentes'}
                />
              )
              })}
              {categoryProducts.length > 6 && (
                <Link to='/tienda' className={styles.viewMoreCard}>
                  <div className={styles.viewMoreContent}>
                    <h3>Ver más...</h3>
                  </div>
                </Link>
              )}
            </div>
          </div>
        ))}
      </section>
    </div>
  )
}

export default ProductCatalog

